export default "__VITE_ASSET__JT9C7dDx__"